/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsCollectionSliderData } from './hosports-collection-slider.data';
import { IHosportsCollectionSliderProps } from './hosports-collection-slider.props.autogenerated';

export interface IHosportsCollectionSliderViewProps extends IHosportsCollectionSliderProps<IHosportsCollectionSliderData> {

}

/**
 *
 * HosportsCollectionSlider component
 * @extends {React.PureComponent<IHosportsCollectionSliderProps<IHosportsCollectionSliderData>>}
 */
class HosportsCollectionSlider extends React.PureComponent<IHosportsCollectionSliderProps<IHosportsCollectionSliderData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsCollectionSlider;
